import { TrophyContainer } from "./TrophyContainer";
import { GameVars } from "../../GameVars";

    export class MatchCell extends Phaser.Group {

        public locked: boolean;
        public boundingBox: Phaser.Rectangle;

        private tournamentData: TournamentData;
        private matchData: MatchData;

         constructor (game: Phaser.Game, tournamentData: TournamentData, matchIndex: number) {

            super(game, null, "match-cell", false);

            this.x = TrophyContainer.CELL_CLICKABLE_LIMIT_LEFT;

            this.scale.y = GameVars.scaleY;

            this.tournamentData = tournamentData;
            this.matchData = this.tournamentData.matchesData[matchIndex];
            this.locked = this.matchData.locked;

            if (this.matchData.whiteBackgroundVisible) {

                const whiteRectangle = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData("white_square"));
                whiteRectangle.scale.setTo(28, 5.6 / GameVars.scaleY);
                whiteRectangle.alpha = .3;
                this.add(whiteRectangle);
            }

            this.addFlags();

            if (!this.locked) {

                this.addScore();

                if (this.matchData.won) {
                    this.addPlayButton();
                }
            }
        }

        public mark(): void {

            const whiteRectangle = new Phaser.Sprite(this.game, -TrophyContainer.CELL_CLICKABLE_LIMIT_LEFT, 0, this.game.cache.getBitmapData("white_square"));
            whiteRectangle.scale.setTo(48, 5.6 / GameVars.scaleY);
            whiteRectangle.alpha = .65;
            whiteRectangle.blendMode = 3;
            this.add(whiteRectangle);
        }

        private addFlags(): void {

            let flag_px = 60;
            let flag_py = 46;

            let flagImage: Phaser.Image;
            let flagImageScale = .75;

            if (this.locked) {
                flagImage = new Phaser.Image(this.game, 17, 17, "texture_atlas_5", "bandera_0000" );
                flagImage.scale.set(flagImageScale);
                flagImage.anchor.set(.5);
                flagImage.x = flag_px;
                flagImage.y = flag_py;
                this.add(flagImage);
            } else {
                // esto es un poco chapuza
                // trabajar mejor la estructura de los datos
                // ya que esto implica un bucle para cada celda
                // la bandera del equipo que toque
                var adversaryID = GameVars.getTeamIDFromTeamName(this.matchData.adversaryName);
                var flagTextureName = "bandera_" + GameVars.formatNumberForTextureAtlas(adversaryID);

                flagImage = new Phaser.Image(this.game, 17, 17, "texture_atlas_5", flagTextureName );
                flagImage.scale.set(flagImageScale);
                flagImage.anchor.set(.5);
                flagImage.x = flag_px;
                flagImage.y = flag_py;
                this.add(flagImage);

                // poner la otra bandera en el caso de que el partido se haya ganado
                if ( this.matchData.won ) {
                     
                    flagImage.alpha = .65;
                    flagImage.x += 12;
                    flagImage.y += 12;

                    const playerID = GameVars.getTeamIDFromTeamName(this.tournamentData.selectedTeamName);
                    flagTextureName = "bandera_" + GameVars.formatNumberForTextureAtlas(playerID);

                    flagImage = new Phaser.Image(this.game, 8, 8, "texture_atlas_5", flagTextureName );
                    flagImage.scale.setTo(flagImageScale);
                    flagImage.anchor.set(.5);
                    flagImage.x = flag_px;
                    flagImage.y = flag_py;
                    this.add(flagImage);
                }

                // si es un nivel de prorroga añadir el icono del cronometro
                let levelData: any = GameVars.getLevelData( this.matchData.id - 1);
                if (levelData[0].time > 0) {

                    const chronometerIcon = new Phaser.Image(this.game, 32, 40, "texture_atlas_5", "icono_crono");
                    chronometerIcon.anchor.set(0.5, 1);
                    this.add(chronometerIcon);

                    // animar al cronometro
                    const pulseTween = this.game.add.tween(chronometerIcon);
                    pulseTween.to ({angle: -8}, 500, Phaser.Easing.Cubic.Out);
                    pulseTween.to ({angle: 8}, 500, Phaser.Easing.Cubic.Out);
                    pulseTween.loop();
                    pulseTween.start();
                }
            }
        }

        private addScore(): void {

            let goalsPlayer: number = this.matchData.goalsPlayer;
            let goalsAdversary = this.matchData.goalsAdversary;

            if (goalsPlayer > 0) {

                const matchResultString = "" + goalsPlayer + "-" + goalsAdversary;

                const resultLabelStyle = { font: "56px Ubuntu", fill: "#000000", align: "center"};
                const resultLabel =  new Phaser.Text(this.game, 170, 16, matchResultString , resultLabelStyle);
                resultLabel.anchor.x = .5;

                if (resultLabel.text.length > 4) {
                    resultLabel.fontSize = 45;
                } 
                this.add(resultLabel);

            } else {
                // no se ha jugado o no se ha conseguido meter ningun gol
                const adversaryName = this.matchData.adversaryName;

                let adversaryNameLabelStyle: any;

                if (adversaryName.length < 12) {
                    adversaryNameLabelStyle = { font: "36px Ubuntu Condensed",
                        fill: "#000000", align: "left", wordWrap: true, wordWrapWidth: 220};

                } else {
                    adversaryNameLabelStyle = { font: "27px Ubuntu Condensed",
                        fill: "#000000", align: "left", wordWrap: true, wordWrapWidth: 220};
                }

                let adversaryNameLabel = new Phaser.Text(this.game, 105, 8, adversaryName , adversaryNameLabelStyle);
                adversaryNameLabel.scale.set(.8, 1);
                this.add( adversaryNameLabel);
            }
        }

        private addPlayButton(): void {

            const playButton = new Phaser.Image (this.game, 260, 50, "texture_atlas_5", "play_opened_level_off");
            playButton.anchor.set(.5);
            this.add ( playButton );
        }
    }
